import React, { useRef, useState } from "react";
import API from "api";
import PopUps from "./PopUps";
import ResourceCheck from "../../components/SectionalTest/ResourceCheck";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import TestHeader from "./TestHeader";
import Questions from "./Questions";
import BottomBtns from "./BottomBtns";
import MockInfo from "./MockInfo";
import { NavLink } from "react-router-dom";
import Unfinished from "./Unfinished";

const TestBody = ({ mockData, setMockData, routeState, soundArr }) => {
  const timerRef = useRef();
  const [questionsFunctions, setQuestionsFunctions] = useState(null);
  const [showMockInfo, setShowMockInfo] = useState(true);
  
  // Fallback functions in case Questions component functions are not ready
  const fallbackFinalObjectCreation = () => {
    let qdata = mockData.questionData[mockData.currentQuestion];
    return {
      type: qdata.subcategory_id,
      id: qdata.id,
      response: true,
      answer: qdata.question,
      script: qdata.audio_script,
      q_ans: qdata.answer
    };
  };

  
  const fallbackFinalSubmit = (obj1) => {
    
    let { questionData, currentQuestion, pending, complete } = mockData;
    let curr = questionData[currentQuestion];
    
    // Check if this is the last question or if timer ran out
    if (currentQuestion === questionData.length - 1 || mockData.timeOut) {
      complete = 1;
    }
    
    let bodyFormData = new FormData();
    
    if (routeState.pending == 1) {
      bodyFormData.append('result_id', routeState.id);
    }
    
    bodyFormData.append('q_count', questionData.length);
    bodyFormData.append('mock_id', routeState.id);
    bodyFormData.append('q_time', 0);
    bodyFormData.append('pending', 1);
    bodyFormData.append('curr_q', 0);
    bodyFormData.append('complete', complete);
    
    // Use the correct question number: current question + qCount + 1
    let questionNumber = mockData.currentQuestion + 1;

    bodyFormData.append('question_number', questionNumber);
    bodyFormData.append('time', mockData.secondCount);
    bodyFormData.append('response[]', obj1.response);
    bodyFormData.append('device', 'website');
    
    // Handle different question types
    if ([1, 2, 3, 4, 5, 21, 22].includes(obj1.type)) {
      bodyFormData.append('answer[]', obj1.q_ans);
      bodyFormData.append('file[]', new Blob(['hello worllllllllllllld']));
    } else if ([6, 7].includes(obj1.type)) {
      bodyFormData.append('answer[]', obj1.q_ans);
      bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
    } else {
      bodyFormData.append('answer[]', obj1.q_ans);
      bodyFormData.append('file[]', new Blob(['hello worlppppppppppppd']));
    }
    
    bodyFormData.append('selected[]', '');
    bodyFormData.append('text[]', obj1.answer);
    bodyFormData.append('type[]', obj1.type);
    bodyFormData.append('id[]', obj1.id);
    bodyFormData.append('duration[]', 0);
    bodyFormData.append('script[]', obj1.script);
    bodyFormData.append('q_ans[]', obj1.q_ans);
    bodyFormData.append('audio_text[]', '');
    bodyFormData.append('html[]', '');
    bodyFormData.append('text_answer[]', '');
    bodyFormData.append('length[]', 0);
    bodyFormData.append('lang[]', '');
    bodyFormData.append('correct[]', '');
    bodyFormData.append('ans[]', obj1.q_ans);
    
    API({
      method: 'POST',
      url: 'submit/mock',
      data: bodyFormData
    }).then(data => {
      let filteredAry = mockData.ids.filter(function (e) {
        return e.id !== obj1.id;
      });
      setMockData((prevState) => {
        return {
          ...prevState,
          qTime: 0,
          ids: filteredAry,
        };
      });
      
      // Call submitFailed API
      setTimeout(() => {
        let formData = new FormData();
        if (mockData.failed && mockData.failed.length > 0) {
          mockData.failed.forEach((value, index) => {
            value.forEach((val, key) => {
              if (key === 'file[]') {
                formData.append('files[]', val);
              } else {
                formData.append(`data[${index}][${key}]`, val);
              }
            });
          });
        }
        
        API({
          method: 'POST',
          url: 'submitFailed/mock',
          data: formData
        }).catch(() => {});
      }, 2000);
    }).catch((error) => {
      console.error('Submit failed:', error);
    });
  };
  const showTest = () => {
    setMockData((prevState) => {
      return {
        ...prevState,
        resourceTested: true,
        secondCount: prevState.mockTime,
      };
    });
  };

  const mainData = showMockInfo ? (
    <MockInfo
      setShowMockInfo={setShowMockInfo}
      categoriesData={mockData.categoriesData}
      initialTime={mockData.initialTime}
      category={mockData.mockCat}
    />
  ) : (
    <div className="content questionsArea">
      <Row>
        <Col xs={12}>
          <Card>
            <TestHeader
              mockData={mockData}
              setMockData={setMockData}
              id={routeState.id}
              ref={timerRef}
              finalObjectCreation={questionsFunctions?.finalObjectCreation || fallbackFinalObjectCreation}
              finalSubmit={questionsFunctions?.finalSubmit || fallbackFinalSubmit}
            />
           {
            mockData.dashboardFlag && mockData.complete == 1  ? (
              <>
              <CardBody>
                <Row className="unselectable">
                  <Col>
                    You've finished this test. Click on the button to 
                    <NavLink to={"/admin/results"}>
                     {" "}
                    <Button
                    color="primary" size="xs"
                    // disabled={(this.state.answer_submitted && this.state.failed_submitted) ? false : true}
                     >
                      See Results
                     </Button>{" "}
                    </NavLink>
                   </Col>
               </Row>
             </CardBody>
              </>
            ) : mockData.complete == 0 && mockData.dashboardFlag ? (
              <>
              <Unfinished/>
              </>
            ) : (
              <>
               <Questions
              mockData={mockData}
              setMockData={setMockData}
              routeState={routeState}
              soundArr={soundArr}
              timerRef={timerRef}
              onFunctionsReady={setQuestionsFunctions}
            />
              </>
            )
           }
          </Card>
        </Col>
        <BottomBtns mockData={mockData} setMockData={setMockData} />
      </Row>
    </div>
  );

  return (
    <>
      <PopUps mockData={mockData} setMockData={setMockData} />
      {mockData.mockCat && !mockData.resourceTested && (
        <ResourceCheck
          showTest={showTest}
          pending={0}
          data={{}}
          cat={mockData.mockCat}
        />
      )}

      {mockData.resourceTested && mainData}
    </>
  );
};

export default TestBody;
